module.exports = __webpack_public_path__ + "img/swiper2.2afbe5be.png";